'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$84() {
  this.bJa = null;
  this.bJb = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$84 as $c_Lpresto_TwoFactorAuthView$$anon$84 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$84.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$84;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$84() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$84 as $h_Lpresto_TwoFactorAuthView$$anon$84 };
$h_Lpresto_TwoFactorAuthView$$anon$84.prototype = $p;
$p.P = (function() {
  if ((!this.bJb)) {
    this.bJa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bJb = true;
  }
  return this.bJa;
});
var $d_Lpresto_TwoFactorAuthView$$anon$84 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$84, "presto.TwoFactorAuthView$$anon$84", ({
  Tx: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$84 as $d_Lpresto_TwoFactorAuthView$$anon$84 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$84.js.map
